<div
  [id]="cellToken"
  class="mode-notebook-cell-group clearfix --with-cell-toolbar"
  [ngClass]="{
    editing: isEditing$ | async,
    'cell-selected': isSelected$ | async,
    '--in-layout-output-collapsed': !(showResult$ | async) && (isInLayout$ | async),
  }"
>
  <div class="cell-indicator"></div>
  <!-- Cell Toolbar -->
  <mode-notebook-cell-menu
    *ngIf="isSelected$ | async"
    [cellToken]="cellToken"
    [contentType]="cellContentType"
    [prevCellToken]="prevCellToken$ | async"
    [nextCellToken]="nextCellToken$ | async"
    [hasResult]="hasResult$ | async"
    [includedInReport]="isInLayout$ | async"
    [isFolded]="isFolded$ | async"
    [isFrozen]="isFrozen$ | async"
    [canRun]="canRunCell$ | async"
    [canFreeze]="canFreeze$ | async"
    [canDelete]="canDelete$ | async"
    (runCell)="runCell($event)"
    (moveCell)="moveCell($event)"
    (deleteCell)="deleteCell()"
    (insertCellAbove)="insertCellAbove($event)"
    (insertCellBelow)="insertCellBelow($event)"
    (toggleFreezeState)="toggleFreezeCell($event)"
    (toggleFoldState)="toggleFoldCell()"
    (contentTypeChange)="updateContentType($event)"
    (toggleIncludedInReportState)="toggleIncludedInReportState($event)"
  ></mode-notebook-cell-menu>

  <!-- Cell Input -->
  <mode-notebook-editor-cell
    *ngIf="cell$ | async"
    [cell]="cell$ | async"
    [session]="session"
    [showInLayout]="!(showResult$ | async) && (isInLayout$ | async)"
    [notebookToken]="notebookToken"
    [readOnly]="readOnly"
  ></mode-notebook-editor-cell>

  <!-- Cell Output -->
  <div *ngIf="showResult$ | async" class="mode-notebook-cell cell-result">
    <div class="mode-notebook-cell-header">OUT [{{ (executionCount$ | async) || '_' }}]</div>

    <!-- Indicator when export is disabled but cell is in layout -->
    <mode-state-indicator-icon
      *ngIf="!(isExportDatasetsEnabled$ | async) && (isInLayout$ | async)"
      [displayStateIcon]="true"
      mainIcon="icon-cell"
      tooltipPlacement="bottom"
      stateIcon="icon-check"
      tooltipHtmlContent="This cell is included in the report"
      class="notebook-cell-state-indicator --output-cell"
      data-test="notebook-cell-state-indicator"
    ></mode-state-indicator-icon>

    <!-- Indicator block when export is enabled -->
    <div class="notebook-cell-state-indicators --output" *ngIf="isExportDatasetsEnabled$ | async">
      <mode-state-indicator-icon
        *ngIf="isInLayout$ | async"
        [displayStateIcon]="true"
        mainIcon="icon-cell"
        tooltipPlacement="bottom"
        stateIcon="icon-check"
        tooltipHtmlContent="Output has been added to Report Builder"
        class="--output-cell"
        data-test="notebook-cell-state-indicator"
      ></mode-state-indicator-icon>

      <mode-state-indicator-icon
        *ngIf="isCellExported$ | async"
        [displayStateIcon]="true"
        mainIcon="icon-dataset"
        tooltipPlacement="bottom"
        stateIcon="icon-check"
        class="--export-cell"
        data-test="notebook-cell-state-indicator"
        [tooltipHtmlContent]="EXPORT_TOOLTIP_HTML_CONTENT"
        [tooltipButtonSelectors]="tooltipButtonSelectors"
        (tooltipButtonClick)="goToDataset(exportedDatasetResult)"
      ></mode-state-indicator-icon>
    </div>

    <!-- Cell Warnings -->
    <mode-notebook-cell-warning [cells]="results$ | async"></mode-notebook-cell-warning>

    <!-- Cell Results -->

    <ng-container *ngIf="results$ | async">
      <ng-container *ngFor="let result of results$ | async | orderByDate | excludeStderr; trackBy: trackByToken">
        <mode-notebook-cell-result [cell]="result" (click)="onResultCellClick()"></mode-notebook-cell-result>
      </ng-container>
    </ng-container>

    <div class="hoverbox"></div>
  </div>
</div>